import { normaliseCreatinine } from "./general";

const COEFFICIENT = 36.5;

export function calculateGfr({
  heightCm,
  serumCreatinine,
  serumCreatinineUnit = "micromoles/L",
}) {
  const height = +heightCm;
  const creat = +serumCreatinine;
  const serumCrMicromol = normaliseCreatinine(
    serumCreatinine,
    serumCreatinineUnit,
  );
  if (
    !(
      height > 0 &&
      creat > 0 &&
      Number.isFinite(height) &&
      Number.isFinite(creat)
    )
  ) return null;
  return Math.round((COEFFICIENT * height) / serumCrMicromol);
}
